var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoxInactive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7053 2.38615C13.1014 2.1662 13.547 2.05078 14 2.05078C14.453 2.05078 14.8986 2.1662 15.2947 2.38615L25.3147 7.95148C25.5224 8.067 25.6955 8.23596 25.816 8.44085C25.9365 8.64574 26 8.87912 26 9.11682V20.0968C25.9999 20.5723 25.8726 21.0392 25.6314 21.449C25.3902 21.8588 25.0437 22.1966 24.628 22.4275L15.2947 27.6141C14.8986 27.8341 14.453 27.9495 14 27.9495C13.547 27.9495 13.1014 27.8341 12.7053 27.6141L3.372 22.4275C2.95647 22.1967 2.61018 21.8591 2.36895 21.4496C2.12773 21.04 2.00035 20.5735 2 20.0981V9.11682C1.99999 8.87912 2.06352 8.64574 2.18402 8.44085C2.30452 8.23596 2.4776 8.067 2.68533 7.95148L12.7067 2.38615H12.7053Z",
    stroke: "#929292",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.6667L20 5M6 15.4373L10 17.6667",
    stroke: "#929292",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.33203L14 14.9987M14 14.9987L26 8.33203M14 14.9987V27.6654",
    stroke: "#929292",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxInactive);
export default __webpack_public_path__ + "static/media/BoxInactive.e5634eed1dd0402caacf2d5ebadb1ce5.svg";
export { ForwardRef as ReactComponent };